import script from "./AssetsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsDetail.vue?vue&type=script&setup=true&lang=js"

import "./AssetsDetail.vue?vue&type=style&index=0&id=1b702944&lang=scss&scoped=true"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b702944"]])

export default __exports__